import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { fetchAuthContext, getCachedAuthContext } from '../api/auth.js';
import Skeleton from './Skeleton';

const BYPASS_PREFIXES = ['/onboarding'];

/** 租户绑定状态与当前路由无关，一次页面加载只向后端校验一次 */
let tenantBindingVerified = false;

/**
 * 已登录但未绑定租户时，引导至组织绑定页（平台管理员除外）
 */
export default function OnboardingGate({ children }) {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [needsOnboarding, setNeedsOnboarding] = useState(false);

  const isBypass = BYPASS_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`));

  useEffect(() => {
    if (isBypass) {
      setChecking(false);
      setNeedsOnboarding(false);
      return;
    }

    let cancelled = false;
    const cached = getCachedAuthContext();
    const cachedPass = cached?.needsTenantJoin === false || cached?.platformAdmin;
    if (cachedPass) {
      setNeedsOnboarding(false);
      setChecking(false);
    }
    if (tenantBindingVerified && cachedPass) {
      return undefined;
    }

    fetchAuthContext({ includeStats: false, backgroundStats: false })
      .then((ctx) => {
        tenantBindingVerified = true;
        if (cancelled) return;
        setNeedsOnboarding(!!ctx?.needsTenantJoin && !ctx?.platformAdmin);
      })
      .catch(() => {
        if (!cancelled && cached?.needsTenantJoin && !cached?.platformAdmin) {
          setNeedsOnboarding(true);
        }
      })
      .finally(() => {
        if (!cancelled) setChecking(false);
      });

    return () => {
      cancelled = true;
    };
  }, [location.pathname, isBypass]);

  if (isBypass) {
    return children;
  }

  if (checking) {
    return <Skeleton type="default" rows={4} />;
  }

  if (needsOnboarding) {
    return <Navigate to="/onboarding/tenant" replace state={{ from: location.pathname }} />;
  }

  return children;
}
